// React
import React, { useEffect, useState, useRef } from "react";
// leaflet
import { Map, Marker, TileLayer, Tooltip, LayersControl } from "react-leaflet";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";
import PropTypes from "prop-types";
import Control from "react-leaflet-control";
import Paper from "@material-ui/core/Paper";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
// component
import HeaderMap from "../../navigation/HeaderStormSurgeMap";
import iconCircle from "../../widgets/map/iconCircle";
import StormSurgeForecastChart from "./StormSurgeForecastChart";
import CurrentLocation from "../../currentlocation/CurrentLocation";
import FullscreenControl from 'react-leaflet-fullscreen';

// const initPath = process.env.MIX_API_HII_URL;
const isIosMobile = /iPad|iPhone|iPod/.test(navigator.userAgent);
const { BaseLayer, Overlay } = LayersControl;

export default function StormSurgeForecastMap(props) {
  const { listStation, handleModalOpen, t = (key) => key } = props;
  const [settingMap] = useState({ position: [13.8, 100.55], zoom: 6 });
  const [showInfo, setShowInfo] = useState(false);
  const mapRef = useRef(null);
  console.log('icon:', iconCircle.green); 
  useEffect(() => {
    document.getElementsByClassName("leaflet-top leaflet-left")[0].style.top =
      "1%";
  }, []);

  const handleChart = (stationName) => {
    const params = {
      header: "กราฟแสดงการเปลี่ยนแปลงระดับน้ำทะเล",
      modalSubHeader: "",
      content: <StormSurgeForecastChart stationName={stationName} />,
    };
    handleModalOpen(params);
  };

  const eachData = (data, i) => {
    const position = [parseFloat(data.lat), parseFloat(data.lon)];
    let icon = iconCircle.blue;
    // console.log(data.warning);
    if (data.warning?.level === 1) {
      icon = iconCircle.orange;
    }    else if (data.warning?.level === 2) {
      icon = iconCircle.red;
    } else {
      icon = iconCircle.green;
    }
    return (
      <Marker
        id={i}
        key={i}
        position={position}
        icon={icon}
        onClick={() => handleChart(data.name_EN)}
        location={[13.8, 100.55]}
        zoom={6}
        datas={listStation}
      >
        {!isIosMobile && (
          <Hidden smDown>
            <Tooltip title={data.name_TH}>
              <span>
                <strong>{data.name_TH}</strong>
              </span>
            </Tooltip>
          </Hidden>
        )}
      </Marker>
    );
  };

  return (
    <>
      <Map
        id="map"
        center={settingMap.position}
        zoom={settingMap.zoom}
        ref={mapRef}
        style={{
          height: "100%",
          width: "100%",
          position: "relative",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
        }}
      >
          <LayersControl position="topright">
            <BaseLayer name="OSM (default)" checked>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                id="OpenStreetMap.Mapnik"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </BaseLayer>
            <BaseLayer name="ESRI">
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                attribution="Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012"
              />
            </BaseLayer>
            {/* <BaseLayer name="Carto">
              <TileLayer
                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
              />
            </BaseLayer> */}
            <BaseLayer name="Satellite">
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution="Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community"
              />
            </BaseLayer>
            <BaseLayer name="Light">
              <TileLayer
                url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                attribution='&copy; OpenStreetMap contributors'
              />
            </BaseLayer>
            <BaseLayer name="stadia">
              <TileLayer
                url={`https://{s}.tile.jawg.io/jawg-dark/{z}/{x}/{y}{r}.png?access-token=m1wmkesPbQtvW852fhyMWn6XHj4XEy7ACy4DnKqXVNDgwGFzzvepTUwemCLloMxG`}
                attribution='&copy; <a href="https://www.jawg.io">Jawg Maps</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </BaseLayer>
          </LayersControl>
        <FullscreenControl position="topleft" />
        {/* {console.log(listStation)} */}
        {listStation.map(eachData)}
        {/* <Box
          mt={{ xs: 1, sm: 2, md: 5 }}
          style={{ position: "absolute", zIndex: 99999, width: "100%" }}
        >
          <HeaderMap />
        </Box> */}
        <CurrentLocation mapRef={mapRef} showOnly={false} />
        <Control position="topleft">
            <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
            <div
              style={{
                backgroundColor: "white",
                padding: "5px",
                borderRadius: "2px",
                width: "30px",
                height: "30px",
                marginLeft:"2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => setShowInfo(prev => !prev)}
            >
              <InfoOutlinedIcon style={{ color: '#000000' }} />
            </div>
          {showInfo && (
            <Paper elevation={3} style={{ borderRadius: "11px", overflow: "hidden", marginLeft: "5px" }}>
              <div style={{ maxWidth: "500px", fontFamily: "Kanit" }}>
                <div style={{
                  backgroundColor: "#ffffff",
                  padding: "10px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}>
                  <InfoOutlinedIcon style={{ color: "#1C1B1F", fontSize: "20px", flexShrink: 0 }} />
                  <span style={{
                    fontFamily: "Kanit",
                    fontWeight: 700,
                    fontSize: "15px",
                    lineHeight: "1.3",
                    color: "#13263A",
                  }}>
                    {t("ระบบคาดการณ์และเตือนภัยล่วงหน้าบริเวณอ่าวไทย")}
                  </span>
                </div>

                {/* Content */}
                <div style={{
                  padding: "10px 14px",
                  fontFamily: "Kanit",
                  fontWeight: 400,
                  fontSize: "12px",
                  marginTop:"-15px",
                  color: "#000000",
                }}>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {t("ระบบคาดการณ์และเตือนภัยล่วงหน้าบริเวณอ่าวไทย เป็นระบบที่ใช้คาดการณ์ระดับน้ำทะเลบริเวณรอบอ่าวไทย ล่วงหน้า 7 วัน ซึ่งใช้ข้อมูลนำเข้าหลักเป็นข้อมูลลมคาดการณ์จากแบบจำลอง WRF-ROMS ของสสน. และได้ผลลัพธ์เป็นระดับน้ำทะเลคาดการณ์ที่เกิดจากการคำนวณจากปัจจัยที่เกี่ยวข้อง 3 ปัจจัย ได้แก่")}
                  </p>
                  <p style={{ margin: "0 0 2px 0" }}>
                    {t("1. ระดับน้ำขึ้นน้ำลง")}
                  </p>
                  <p style={{ margin: "0 0 2px 0" }}>
                    {t("2. คลื่นพายุซัดฝั่ง")}
                  </p>
                  <p style={{ margin: "0 0 6px 0" }}>
                    {t("3. คลื่นยกตัว")}
                  </p>
                  <p style={{ margin: 0}}>
                    {t("โดยระบบจะมีการประมวลผลรายวัน และมีแจ้งเตือนการเฝ้าระวังรายสถานี โดยหากสถานีใดมีระดับน้ำทะเลคาดการณ์สูงอยู่ในเกณฑ์เฝ้าระวังในช่วง 3 วันข้างหน้า สีของสถานีจะทำการเปลี่ยนจากสีน้ำเงินเป็นสีส้ม")}
                  </p>
                </div>

                {/* Footer */}
                <div style={{
                  padding: "6px 14px 10px",
                  fontFamily: "Kanit",
                  fontWeight: 700,
                  fontSize: "12px",
                  color: "#13263A",
                }}>
                  {t("อ้างอิงเอกสารวิชาการ")}
                  <div style={{ fontWeight: 400, marginTop: "2px", display: "flex", flexDirection: "column", gap: "4px" }}>
                    <a href="https://iahrapd2020.xsrv.jp/proceedings/pdf/6-9-1.pdf" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[1] STORM SURGE FORECASTING AND INUNDATION ESTIMATION DURING TROPICAL STROM PABUK 2019 IN THE SOUTHERN COAST OF THAILAND ")}
                    </a>
                    <a href="https://henry.baw.de/server/api/core/bitstreams/38e77472-6154-446d-9ed5-78feea8f1b88/content" target="_blank" rel="noopener noreferrer" style={{ color: "#757575", fontSize: "8px" }}>
                      {t("[2] Development of an Operational Storm Surge Forecasting System for the Gulf of Thailand")}
                    </a>
                  </div>
                </div>

              </div>
            </Paper>
          )}
          </div>
          </Control>
      </Map>
    </>
  );
}

StormSurgeForecastMap.propTypes = {
  listStation: PropTypes.array.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
};
